module.exports = __webpack_public_path__ + "img/2_gucci.e8dc4e1b.jpg";